// extracted by mini-css-extract-plugin
module.exports = {"container":"TabRadioGroup_container__W2Dc5","item":"TabRadioGroup_item__dbveb","hasBorder":"TabRadioGroup_hasBorder__HkAwB"};